// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1ThaX","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3GVP3"};